var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5614_1461)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5614_1461",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 -1.00004H25V24H0V-1.00004Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5614_1461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1673 16.0641C8.80873 16.7262 5.53919 14.5336 4.87669 11.1758C4.21536 7.81757 6.40794 4.54764 9.76654 3.88514C13.124 3.22303 16.3939 5.41639 17.0564 8.77499C17.7185 12.1328 15.5244 15.4027 12.1673 16.0641ZM18.5869 15.723C17.8486 14.8324 18.2244 14.2984 18.4267 14.0109C18.4548 13.9719 18.4806 13.9363 18.4998 13.8996C20.1033 10.7887 19.6451 7.06444 17.3287 4.41483C15.3275 2.12342 12.2376 1.06482 9.26732 1.65076C7.8245 1.93603 6.48224 2.59618 5.37552 3.56483C3.67942 5.04725 2.66497 7.1078 2.52239 9.3664C2.37864 11.6242 3.12395 13.8117 4.6181 15.5227C6.61693 17.809 9.7017 18.8664 12.6689 18.2813C13.0447 18.207 13.4193 18.1063 13.7794 17.982C13.8263 17.966 13.8747 17.9371 13.9279 17.9074C14.0572 17.8371 14.2173 17.7492 14.4134 17.7106C14.8447 17.6258 15.2455 17.8059 15.6388 18.2629C16.3458 19.0844 17.8384 20.7563 17.8384 20.7563C18.0658 21.0161 18.3573 21.2118 18.6839 21.3238C19.0105 21.4358 19.3608 21.4602 19.6998 21.3945C20.032 21.3292 20.3412 21.1775 20.5962 20.9547C20.9869 20.6133 21.2197 20.1383 21.2533 19.6176C21.27 19.3607 21.2358 19.1031 21.1527 18.8595C21.0695 18.6159 20.9391 18.3911 20.7689 18.1981C20.6564 18.0691 19.2673 16.5469 18.5869 15.723Z",
    fill: "#92929E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5614_1461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b399fad855bb566df789addceb1086ac.svg";
export { ForwardRef as ReactComponent };